import { Currency } from '../bank-account/bank-account';

/** The fund page's form (#5785). Numbers stay null until typed so required checks fire. */
export interface PettyCashFundFormModel {
  name: string;
  description: string | null;
  currency: Currency | null;
  custodianUsername: string | null;
  memberUsernames: string[];
  minRevolvingBalance: number | null;
  maxRevolvingBalance: number | null;
  glAccountReference: string | null;
  claimPolicyReference: string | null;
}

export const pettyCashFundFieldLabels: Record<keyof PettyCashFundFormModel, string> = {
  name: 'PettyCashFund_Field_Name',
  description: 'PettyCashFund_Field_Description',
  currency: 'PettyCashFund_Field_Currency',
  custodianUsername: 'PettyCashFund_Field_Custodian',
  memberUsernames: 'PettyCashFund_Field_Members',
  minRevolvingBalance: 'PettyCashFund_Field_Min',
  maxRevolvingBalance: 'PettyCashFund_Field_Max',
  glAccountReference: 'PettyCashFund_Field_GlAccount',
  claimPolicyReference: 'PettyCashFund_Field_Policy',
};
